import { clsx } from 'clsx';

export type IconographyVariant =
  | 'check_circle'
  | 'close'
  | 'error'
  | 'keyboard_double_arrow_up'
  | 'expand_more'
  | 'filter_list'
  | 'filter_alt'
  | 'expand_more'
  | 'progress_activity'
  | 'visibility_off'
  | 'visibility'
  | 'home'
  | 'folder_copy'
  | 'account_circle'
  | 'keyboard_arrow_down'
  | 'info'
  | 'hide_image';

export type IconStyle = 'rounded' | 'outlined';

export type IconographyProps = {
  variant: IconographyVariant;
  style?: IconStyle;
  className?: string;
};

export function Iconography({
  variant,
  className,
  style = 'outlined',
  ...props
}: IconographyProps) {
  const Component = 'span';

  return (
    <Component
      {...props}
      className={clsx(
        {
          'material-symbols-rounded': style === 'rounded',
          'material-symbols-outlined': style === 'outlined',
        },
        className,
      )}
    >
      {variant}
    </Component>
  );
}
